<template>
    <div class="wrap">
        <div class="main" id="scroll">
            <div class="header">
                <h1><img src="../assets/img/home/logo.png" alt=""></h1>
                <div class="time">
                    {{ time }}
                </div>
            </div>
            <div class="banner">
                <img src="../assets/img/home/banner.jpg" alt="">
                <div class="goin">
                    <span @click="goin">立即认证</span>
                    <a href="javascript:;" @click="playVideo">
                        <div>
                            <b>平台介绍</b>
                            <van-icon class-prefix="vant-ali-icon_video" class="myfont" />
                        </div>
                    </a>
                </div>
                <div class="dramaGuid" v-if="!isPromote">
                    <a @click="lookDoc">短剧漫剧版权保护实操指引</a>
                    <van-icon name="arrow" />
                </div>
                <!-- <div class="guidance">
                    <dl>
                        <dt>学术指导：</dt>
                        <dd>
                            <p>中国法学会知识产权法学研究会 </p>
                            <p>刘春田、金克胜工作室</p>
                        </dd>
                    </dl>
                </div> -->
            </div>
            <div class="gift" v-if="isPromote && validateInfo.activityStatus===0">
                <div class="text">
                    <img src="@/assets/images/gift.png" alt="">
                    <div class="text-right">
                        <p>立即注册得价值300元优惠券大礼包</p>
                        <h4 @click="goin">
                            <span class="go-register">去注册</span>
                            <i class="el-icon-arrow-right"></i>
                        </h4>
                    </div>
                </div>
            </div>
            <div class="why">
                <div class="cnt">
                    <h3 class="title">
                        为什么要用可信时间戳？
                        <p><span></span></p>
                    </h3>
                    <div class="info">
                        <b>从创意开始</b>，
                        所有创作都是有价值的，在创作后立即申请可信时间戳认证，可以即时获得司法认可的权属证明，有效保护您的知识产权！
                    </div>
                    <div class="pic">
                        <img src="../assets/img/home/why.png" alt="">
                        <div class="btn">
                            <span @click="goin">立即认证</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trait">
                <div class="cnt">
                    <h3 class="title">
                        为什么选择可信时间戳
                        <p><span></span></p>
                    </h3>
                    <div class="ul_wrap">
                        <ul>
                            <li>
                                <div class="icon">
                                    <img class="trait_icon1" src="../assets/img/home/trait1.png" alt="">
                                </div>
                                <h5>司法认可</h5>
                                <h5>
                                    使用可信时间戳证据的<br>裁判文书{{accountNum.precedentTotal}}件 <br>
                                    <span>（来源：中国裁判文书网）</span>
                                </h5>
                            </li>
                            <li>
                                <div class="icon">
                                    <img class="trait_icon1" src="../assets/img/home/trait2.png" alt="">
                                </div>
                                <h5 style="margin-bottom: 5px;">世界知识产权组织、<br>国家版权局：<br>“中国版权金奖” 保护奖</h5>
                                <h5>国家版权局：版权保护<br>新技术研究推广站点</h5>
                                <!-- <h6>
                                    中国版权金奖-保护奖 <br>
                                    <span>国家版权局 世界知识产权组织</span>
                                </h6> -->
                            </li>
                            <li>
                                <div class="icon">
                                    <img class="trait_icon1" src="../assets/img/home/trait3.png" alt="">
                                </div>
                                <h5>ISO/IEC 27001<br>信息安全管理体系认证</h5>
                                <h5>
                                    公安等保三级认证
                                </h5>
                            </li>
                            <li>
                                <div class="icon">
                                    <img class="trait_icon1" src="../assets/img/home/trait4.png" alt="">
                                </div>
                                <h5>安全保密</h5>
                                <h5>
                                    作品、数据可不上传<br>
                                    保密认证，隐私安全
                                </h5>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="flow">
                <div class="cnt">
                    <h3 class="title">
                        知产保护 仅需三步
                        <p><span></span></p>
                    </h3>
                    <div class="tab">
                        <p :class="active==0?'active':''" @click="tab(0)">网站申请</p>
                        <p :class="active==1?'active':''" @click="tab(1)">接口对接</p>
                    </div>
                    <div class="flow-img">
                        <div class="flow-pic" v-if="active==0">
                            <img src="../assets/img/home/flow1.png" alt="">
                            <span @click="goin">立即认证</span>
                        </div>
                        <div class="flow-pic" v-else>
                            <img src="../assets/img/home/flow2.png" alt="">
                            <span @click="show=true">立即接入</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="case" v-if="!isJxs && !isPromote">
                <h3 class="title">
                    司法采信
                    <p><span></span></p>
                </h3>
                <div class="case-cnt">
                    <p class="data_from">数据来源：中国裁判文书网</p>
                    <div class="data_show">
                        <p>已有<b>{{accountNum.precedentTotal}}</b>篇裁判文书</p>
                        <p>覆盖全国 <b>{{accountNum.provinceTotal}}</b>个省 ，<b>{{accountNum.courtTotal}}</b>家法院</p>
                    </div>
                    <div class="case-tab">
                        <div class="tab-name">
                            <ul>
                                <li @click="tabDictionary(index,item.id)" :class="tabactive==index?'active':''" v-for="(item,index) in dictionaryList" :key="item.id">{{item.name}} <span></span></li>
                            </ul>
                        </div>
                        <div class="tab-cnt">
                            <ul class="item">
                                <li v-for="item in precedentList" :key="item.id" @click="lookDetail(`/precedent/detail/${item.id}`)">
                                    <div class="item-cnt">
                                        {{item.title}}
                                    </div>
                                    <div class="item-footer">
                                        案号：{{item.precedentNo}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="more">
                            <span @click="openTsa('case')">查看更多</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="login" id="loginForm" v-if="isJxs">
                <TsaLoginForm />
            </div>
            <div class="login" v-if="isPromote" id="loginForm">
                <PromoteLoginForm :validateInfo="validateInfo" />
            </div>

            <div class="honor">
                <h3 class="title">
                    荣誉资质
                    <p><span></span></p>
                </h3>
                <div class="honor_cnt">
                    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                        <van-swipe-item>
                            <div class="img_wrap">
                                <img class="honor_img1" src="../assets/img/home/honor1.png" alt="">
                            </div>
                            <div class="honor_des">
                                国家版权局与世界知识产权组织WIPO： <br>
                                中国版权金奖-保护奖
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="img_wrap">
                                <img class="honor_img1" src="../assets/img/home/honor2.png" alt="">
                            </div>
                            <div class="honor_des">
                                中国版权协会常务理事单位
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="img_wrap">
                                <img class="honor_img1" src="../assets/img/home/honor5.png" alt="">
                            </div>
                            <div class="honor_des">
                                国家版权交易中心联盟理事单位
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="img_wrap">
                                <img class="honor_img2" src="../assets/img/home/honor3.png" alt="">
                            </div>
                            <div class="honor_des">
                                查处侵权盗版案件有功单位-三等奖
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="img_wrap">
                                <img class="honor_img2" src="../assets/img/home/honor4.png" alt="">
                            </div>
                            <div class="honor_des">
                                知识产权公益基金会荣誉捐赠人
                            </div>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="questions">
                <h3 class="title">
                    常见问题
                    <p><span></span></p>
                </h3>
                <div class="questions_cnt">
                    <van-collapse v-model="activeNames" accordion>
                        <van-collapse-item v-for="(item,index) in questionsList" :key="index" :name="index">
                            <template #title>
                                <div class="slot_title"><p><span v-html="item.question"></span></p></div>
                            </template>
                            <p v-html="item.answer"/>
                        </van-collapse-item>
                    </van-collapse>
                    <div class="btn">
                        <span @click="openTsa('qusetion')">查看更多</span>
                    </div>
                </div>
            </div>
            <van-dialog
                class="applyDia"
                v-model="show"
                title="提交接入申请"
                confirmButtonColor="#008AFF"
                confirmButtonText="下一步"
                :before-close="beforeClose1"
                close-on-click-overlay
                >
                <p>请选择您的身份：</p>
                <div>
                    <van-radio-group v-model="radio" direction="horizontal" class="myradio">
                        <van-radio :name="1">个人</van-radio>
                        <van-radio :name="0">企业</van-radio>
                    </van-radio-group>
                </div>
            </van-dialog>
            <van-dialog
                class="applyDia2"
                v-model="show2"
                title="提交接入申请"
                showCancelButton
                cancelButtonText="上一步"
                confirmButtonColor="#008AFF"
                confirmButtonText="提交"
                :before-close="beforeClose2"
                close-on-click-overlay
                >
                <p>很快，我们的专业顾问会与您联系。</p>
                <div class="form">
                    <van-form @submit="submit" ref="form" >
                        <van-field
                            v-if="radio==0"
                            class="inputBody"
                            v-model="form.enterpriseName"
                            name="用户名"
                            placeholder="请输入企业名称"
                            :rules="[{ required: true, message: '请输入企业名称' }]"
                        />
                        <van-field
                            class="inputBody"
                            v-model="form.name"
                            placeholder="请输入联系人姓名"
                            :rules="[{ required: true, message: '请输入联系人姓名' }]"
                        />
                        <van-field
                            class="inputBody"
                            v-model="form.phone"
                            placeholder="请输入手机号"
                            :rules="[{ required: true, message: '请输入手机号'},{validator:isphoneNum,message:'请输入正确的手机号码'}]"
                        />
                        <div class="yzmwrap">
                            <van-field
                                class="inputBody"
                                v-model="form.captchaCode"
                                placeholder="请输入验证码"
                                :rules="[{ required: true, message: '请输入验证码' }]"
                            />
                            <span class="yzmbtn" :disabled="disabled" @click="getVerificationCode()">{{yzmtext}}</span>
                        </div>
                        <van-field
                            class="inputBody textBody"
                            rows="3"
                            type="textarea"
                            v-model="form.description"
                            placeholder="请输入需求描述"
                            show-word-limit
                            maxlength="200"
                            :rules="[{ required: true, message: '请输入需求描述' }]"
                        />
                    </van-form>
                </div>
            </van-dialog>
            <Footer/>
            <div class="videoZhe" v-if="isShowVideo">
                <div class="vid">
                    <video-player
                        class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                    <span class="close" @click="closeVideo">
                        <van-icon name="cross" />
                    </span>
                </div>
            </div>
        </div>
        <div id="captcha-element"></div>
    </div>
</template>

<script>
import NoTrace from '@/utils/noTrace';
import {me} from "@/api/service";
import { getCurrentTime,precedent,questionAnswer,precedentStatistics} from "../api/tsaService";
import { sendSmsCode,sendTools} from "../api/copyright/copyright";
import { validate } from '@/api/promote'
import Footer from "../components/Footer";
import moment from "moment";
import TsaLoginForm from '@/components/Login/loginForm'
import PromoteLoginForm from '@/components/Login/loginForm/promoteLogin'
import {removeUrlParams} from "@/utils/utils";
let interval = null;
export default {
    metaInfo: {
    title: '可信时间戳知识产权保护平台_联合信任时间戳服务中心',
    meta: [
        {
            name: 'keyWords',
            content: '知识产权,著作权,版权,艺术作品,小说文章,摄影图片,原创视频,时间戳,可信时间戳,知识产权,电子证据,电子取证,电子签名,区块链,手机取证,国家授时中心'
        },
        {
            name: 'description',
            content: '联合信任时间戳服务中心提供基于可信时间戳各类解决方案，可信时间戳相关裁判文书超50000件,遍布31个省,超670家法院，可信司法依据。广泛应用于可信时间戳电子取证、电子签名、版权保护、知识产权、电子证据固化等领域;场景包括:电商维权,商标侵权取证,商业秘密保护,网络侵权取证,著作权保护,肖像权侵权取证,电话录音取证,现场录像取证等等'
        }
        ],
    },
    data() {
        return {
            token:'',
            validateInfo:'',
            observer: null,
            videoUrl:process.env.VUE_APP_TSA + '/guide/detail/1040',
            phoneNum:'',
            show:false,
            show2:false,
            time:'',
            active:0,
            dictionaryList:[
                {
                    id:970753,
                    name:'商标',
                    type: "precedent_column",
                },
                {
                    id:971777,
                    name:'专利',
                    type: "precedent_column",
                },
                {
                    id:972801,
                    name:'著作权',
                    type: "precedent_column",
                },
            ],
            precedentList:[],
            accountNum:{},
            tabactive:0,
            activeNames: 0,
            questionsList: [],
            radio:'',
            currentTime:61,
            yzmtext:"获取验证码",
            disabled:false,
            form:{
                enterpriseName:'',
                name:'',
                phone:'',
                captchaCode:''
            },
            nvc:'',
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [],
                poster: "", // 封面地址
                notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, // 当前时间和持续时间的分隔符
                    durationDisplay: true, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true, // 是否显示全屏按钮
                },
            },
            isShowVideo: false,
            videoPath: '',
            videoTSAPath: "https://evidence-public.oss-cn-beijing.aliyuncs.com/content/banner/40cde858e2ec420cb0115d29d378ac0c/%E7%9F%A5%E8%AF%86%E4%BA%A7%E6%9D%83%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%BC%95.mp4",
        };
    },

    components: {
        Footer,
        TsaLoginForm,
        PromoteLoginForm
    },

    computed: {
        isJxs(){
            if(this.$route.query.code && !this.token){
                return true
            }
            return false
        },
        isPromote(){
            if(this.$route.query.promoteCode && !this.token){
                return true
            }
            return false
        },
    },

    created() {
        if(this.$route.query.code && this.$route.query.promoteCode){
            window.location.href=removeUrlParams(window.location.href,['code','promoteCode'])
            return
        }
        if(this.$route.query.promoteCode){
            zhuge.track('裂变-推广链接曝光',{
                '推广分类':'版权保护',
                '渠道':'H5',
            })
        }

        this.initTime();
        this.getPrecedentList();
        this.getQuestionList();
        this.getNumAccount();
        me().then((res) => {
            this.token=res.accessToken;
        }).catch((err)=>{
            console.log(err);
            if(this.isPromote){
                this.getPromoteStatus();
            }
        })
    },

    mounted() {
        //this.observerOpen('loginForm')
        NoTrace.init('captcha-element', 'captcha-button')
        if(this.isJxs){
          zhuge.track("经销分享落地页_版权保护", {
            '推广码':this.$route.query.code
          })
        }
    },
    beforeDestroy() {
        NoTrace.reset();
        interval && clearInterval(interval);
        interval=null;
        this.observerClose();
    },

    //灰化处理
    // beforeCreate() {
    //     document.getElementsByTagName("html")[0].className="gray";
    // },
    // beforeDestroy() {
    //     document.getElementsByTagName("html")[0].removeAttribute("class","gray");
    // },

    methods: {
        lookDoc(){
            zhuge.track('知产_首页_短剧漫剧实操指引',{
                "位置":'Banner'
            },()=>{
                window.location.href='https://evidence-public.oss-cn-beijing.aliyuncs.com/content/zhiyin/%E7%9F%AD%E5%89%A7%E6%BC%AB%E5%89%A7%E7%89%88%E6%9D%83%E4%BF%9D%E6%8A%A4%E6%93%8D%E4%BD%9C%E6%8C%87%E5%BC%95v1.0%28%E8%AF%81%E4%B9%A6%E7%AD%BE%E5%90%8D%29.pdf';
            })
            
        },
        async getPromoteStatus(){
            try {
                let res = await validate({promoteCode:this.$route.query.promoteCode})
                this.validateInfo=res;
            } catch (error) {
                console.log(error)
            }
        },
        observerClose(){
            if (this.observer) {
                this.observer.disconnect();
                this.observer=null;
            }
        },
        observerOpen(id){
            this.observer = new IntersectionObserver((entries, observer) => {
            }, {
                rootMargin: '0px',
                threshold: 1,// 交叉比例达到100%时触发回调
            });
            this.$nextTick(() => {
                const element = document.getElementById(id);
                if (element) {
                    this.observer.observe(element);
                }
            });
        },
        scrollTo(sectionId){
            const element = document.getElementById(sectionId);
            if (element) {
                const position = element.offsetTop - 20;
                const scrollDom=document.getElementById('scroll');
                scrollDom.scrollTo({
                    top: position,
                    behavior: 'smooth'
                });
            }
        },
        isphoneNum(val){
            const reg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(val)) {
                return false;
            }
            return true
        },
        initTime() {
            var ntpDate = null,
                nowDate = null,
                td = null;
            let _this = this;
            initTime();
            function initTime() {
                getCurrentTime().then(res => {
                    ntpDate = res;
                    nowDate = new Date().getTime();
                    td = ntpDate - nowDate;
                    nowDate = nowDate + td;
                });
            }

            function getDate() {
                if (ntpDate == null) {
                return;
                } else {
                var now = new Date().getTime() + td;
                if (Math.abs(parseInt(now) - parseInt(nowDate)) > 1000) {
                    ntpDate = null;
                    initTime();
                } else {
                    nowDate = now;
                    var time1 = moment(now).format("YYYY-MM-DD HH:mm:ss:SSS");
                    _this.time = `${time1}`;
                    _this.utc = `(${clientTimeZone()})`;
                }
                }
            }

            function clientTimeZone() {
                var munites = new Date().getTimezoneOffset();
                var hour = parseInt(munites / 60);
                var munite = munites % 60;
                var prefix = "-";
                if (hour < 0 || munite < 0) {
                // prefix = "+";
                hour = -hour;
                if (munite < 0) {
                    munite = -munite;
                }
                }
                hour = hour + "";
                munite = munite + "";
                if (hour.length == 1) {
                hour = "0" + hour;
                }
                if (munite.length == 1) {
                munite = "0" + munite;
                }
                return prefix + hour + ":" + munite;
            }
            Date.prototype.format = function(fmt) {
                var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小时
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                S: this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (this.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
                }
                for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length)
                    );
                }
                }
                return fmt;
            };
            setInterval(() => getDate(), 1);
        },
        openTsa(name){
            switch (name) {
                case 'qusetion':
                    window.open(process.env.VUE_APP_TSA+'/question?sourceType=952310');
                    break;
                case 'case':
                    window.open(process.env.VUE_APP_TSA+'/precedent');
                    break;
            }
        },
        lookDetail(path){
            window.open(process.env.VUE_APP_TSA + path);
        },
        goin(){
            if(this.isJxs || this.isPromote){
                this.scrollTo('loginForm')
                return
            }
            this.$router.push({path:'/time/ApplyTime',query:this.$route.query})
        },
        tab(n){
            this.active=n;
        },
        tabDictionary(n,id){
            console.log(id)
            let that=this;
            this.tabactive=n;
            precedent({
                size:3,
                dictionaryId:id,
                page:1,
                sort:1,
            }).then((res) => {
                console.log(res)
                that.precedentList=res.data;
            }).catch((err) => {
                 console.log(err)
            });
        },
        getPrecedentList(){
            let that=this;
            precedent({
                size:3,
                dictionaryId:970753,
                page:1,
                sort:1,
            }).then((res) => {
                console.log(res)
                that.precedentList=res.data;
            }).catch((err) => {
                 console.log(err)
            });
        },
        getQuestionList(){
            let that=this;
            questionAnswer({
                size:4,
                sourceType:952310,
                page:1,
                sort:1,
            }).then((res) => {
                console.log(res)
                that.questionsList=res.data;
            }).catch((err) => {
                 console.log(err)
            });
        },
        async getNumAccount() {
            let res = await precedentStatistics();
            console.log(res);
            if (res) {
                this.accountNum = res;
            }
        },
        async getVerificationCode() {
            let that = this;
            let { phone } = that.form;
            if (!phone) {
                that.$toast("手机号不能为空");
                return false;
            }
            let reg = /^1[23456789]\d{9}$/;
            if (!reg.test(phone)) {
                that.$toast("手机号格式不正确");
                return false;
            }
            this.getCode();
            that.disabled = true;
            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                this.nvc = nvc
            }, this.executeFun, {
                phone,
                nvc: this.nvc,
                afsVersion: 2
            })
        },

        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendSmsCode(params);
                    resolve(res)
                    that.$toast(res.message);
                }catch (err) {
                    reject(err)
                    console.log(err)
                    that.$toast.fail(err.message)
                    clearInterval(interval);
                    that.yzmtext = "获取验证码";
                    that.disabled = false;  
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = 60;
                    that.disabled = false;
                }
            }, 1000);
        },
        beforeClose1(action, done){
            if (action === 'confirm') {
                if(!this.radio&&this.radio!==0){
                    this.$toast('请选择您的身份')
                    done(false)
                }else{
                    this.show2=true;
                    done()
                }
            }else{
                done()
            }
        },
        beforeClose2(action, done){
            if (action === 'confirm') {
                this.$refs.form.submit()
                done(false)
            } else if(action === 'cancel'){
                this.show=true;
                done();
            }else{
                done();
            }
        },
        submit(values){
            console.log(values);
            let that=this;
            let { phone, enterpriseName, name, captchaCode, description} = that.form;
            let style = that.radio;
            sendTools({
                phone,
                applyId: 998081,
                enterpriseName,
                name,
                style,
                captchaCode,
                from:1,
                description,
            }).then((res) => {
                that.$toast.success('申请成功！');
                that.yzmtext = "获取验证码";
                that.show2=false;
                that.radio = "";
                that.form={};
                that.$refs.form.resetValidation();
                that.currentTime=61;
                that.disabled=false;
                clearInterval(interval);
            }).catch((err) => {
                console.log(err)
                that.$toast(err.message);
                that.yzmtext = "获取验证码";
                that.currentTime=61;
                that.disabled=false;
                clearInterval(interval);
            });
        },
        playVideo(){
            let filePath=this.videoTSAPath;
            this.playerOptions.sources.push({
                src:filePath,
                type: "video/mp4",
            });
            this.isShowVideo = true;
            let url =process.env.VUE_APP_TSA +"/playVideo?videoPath=" +filePath;
            this.$nextTick(() => {
                this.videoPath = url;
            });
        },
        closeVideo() {
            this.playerOptions.sources.shift();
            this.isShowVideo = false;
            this.shareActive = false;
        },
    },
};
</script>
<style src="@/assets/css/index.less" lang='less' scoped></style>
<style lang='less'>
.van-swipe__indicator{
    background-color:#ccc !important;
}
.van-swipe__indicators .van-swipe__indicator--active{
    background: #6090FF !important;
}
.van-field__word-limit{
    float:right
}

</style>